import fileDownload from 'js-file-download'
import api from './api'

const individuallyHome = ({ Nome, Captcha, Year, Semester }) => api.post('/Aluno/individual/home', { Nome, Captcha, Year, Semester })

const individually = (Nome, Year, Semester) => api.post('/Aluno/individual', { Nome, Year, Semester })

const sendStudents = (ids) => api.post('/Aluno', ids)

const downloadExampleSheet = async () => {
  const response = await api.get('/Aluno/planilha/download', { responseType: 'arraybuffer' })
  fileDownload(response.data, 'PlanilhaExemplo.xlsx', response.headers['content-type'])
  return response
}

const uploadSheet = async (names, year, semester) => {
  return await api.post(`/Aluno/planilha/upload/${year}/${semester}`, names)
}

const studentsList = (year, semester, { pageNumber, pesquisa }) => api.get(`/Aluno/${year}/${semester}`, { params: { pageNumber, pesquisa } })

const downloadStudentsListSheet = async (year, semester) => {
  const response = await api.get(`/Aluno/download/${year}/${semester}`, { responseType: 'arraybuffer' })
  fileDownload(response.data, 'ListaAprovados.xlsx', response.headers['content-type'])
  return response
}

const consolidate = (year, semester) => api.get(`/Aluno/consolidado/${year}/${semester}`)

const dashboardData = (year) => api.get(`/Aluno/dashboard/${year}`)

const deleteById = (id) => api.delete(`/Aluno/${id}`)

export const StudentService = {
  individuallyHome,
  individually,
  sendStudents,
  downloadExampleSheet,
  uploadSheet,
  studentsList,
  downloadStudentsListSheet,
  consolidate,
  dashboardData,
  deleteById,
}
